import { normalizePhoneNumber } from '../utils/helpers';

export const SUPER_ADMIN_PHONES = [
  '5322014464', '05322014464', '+905322014464',
  '5322014494', '05322014494', '+905322014494',
  '5324963732', '05324963732', '+905324963732',
  '5421259029', '05421259029', '+905421259029',
  '5446979787', '05446979787', '+905446979787',
];

export const SUPER_ADMIN_EMAILS = [
  'seliminyazilimhesabi@gmail.com'
];

export const SUPER_ADMIN_IDS = [
  '322e33c4-a6eb-4331-9e31-e7eab6739b20',
  '4bcb4586-ad2d-4133-91ef-1abfcbf06938'
];

/**
 * Telefon numarasının admin olup olmadığını kontrol eder
 */
export const isAdminPhone = (phoneNumber?: string): boolean => {
  if (!phoneNumber) return false;

  try {
    const normalizedPhone = normalizePhoneNumber(phoneNumber);
    // Hem normalize hem raw hem stripped kontrol
    const stripped = phoneNumber.replace(/[^0-9]/g, '').replace(/^90/, '').replace(/^0/, '');
    return SUPER_ADMIN_PHONES.includes(normalizedPhone) ||
           SUPER_ADMIN_PHONES.includes(phoneNumber) ||
           SUPER_ADMIN_PHONES.includes(stripped);
  } catch {
    return false;
  }
};

/**
 * Kullanıcının admin olup olmadığını kontrol eder (telefon + email + id + rol)
 */
export const isAdmin = (user?: { phone_number?: string; email?: string; id?: string; role?: string } | null): boolean => {
  if (!user) return false;

  // 1. ID check (hardcoded — role tek başına admin yetkisi vermez)
  if (user.id && SUPER_ADMIN_IDS.includes(user.id)) return true;

  // 3. Email check
  if (user.email && SUPER_ADMIN_EMAILS.includes(user.email)) return true;

  // 4. Phone check
  if (isAdminPhone(user.phone_number)) return true;

  return false;
};
